import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "11.293",
  height: "13.817"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "none",
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2",
      d: "M5.647 13.217s5.047-2.523 5.047-6.308V2.492L5.647.6.6 2.492v4.416c0 3.785 5.047 6.309 5.047 6.309"
    }, null, -1)
  ])))
}
export default { render: render }